import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChart5Props } from './BarChart5';

export const BarChart5 = loadableWithFallback<BarChart5Props>(() => import('./BarChart5'));
